import { render, staticRenderFns } from "./datawall.vue?vue&type=template&id=5e233d90&scoped=true"
import script from "./datawall.vue?vue&type=script&lang=js"
export * from "./datawall.vue?vue&type=script&lang=js"
import style0 from "./datawall.vue?vue&type=style&index=0&id=5e233d90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e233d90",
  null
  
)

export default component.exports